import React, { useState } from 'react';
import { iconBurgerMenu, iconLogout } from 'src/integration/assets/AssetsProvider';
import styled, { css } from 'styled-components';
import colors from 'src/integration/styles/colors';
import Icon from 'src/presentation/components/ui/Icon';
import WhiteBox from 'src/presentation/components/ui/WhiteBox';
import Header from 'src/presentation/components/ui/Header';
import { useAuth } from 'src/toolkit/services/AuthProvider';

interface ComponentProps {
  site: string;
  pageName?: string;
}

const Root = styled.div`
  ${() => css`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 24px 16px;
  `}
`;

const Menu = styled('ul')`
  ${() => css``}
`;

const MenuItem = styled('li')`
  ${() => css`
    width: 100%;

    &:not(:first-child):not(:last-child) {
      padding: 12px 0;
    }

    &:first-child {
      padding-bottom: 12px;
    }

    &:last-child {
      padding-top: 12px;
    }

    a {
      text-decoration: none;
      color: ${colors.primaryYankeesBlue};
      font-size: 14px;
      border-radius: 50px;
      text-wrap: nowrap;
      display: inline-block;
      width: 100%;

      &.active {
        font-weight: 500;
      }
    }
  `}
`;

const Title = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`;

const Paragraph = styled.div`
  ${() => css`
    font-size: 16px;
    font-weight: 500;
    text-align: left;
  `}
`;

const IconWrapper = styled.div`
  ${() => css`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${colors.primaryWhite};
    border: 1px solid ${colors.grey4};
    padding: 8px;
    border-radius: 50%;
  `}
`;

const LeftSide = styled.div`
  ${() => css`
    position: relative;
  `}
`;

const RightSide = styled.div`
  ${() => css``}
`;

const Modal = styled.div`
  ${() => css`
    position: absolute;
    top: 50px;
  `}
`;

const StyledWhiteBox = styled(WhiteBox)`
  ${() => css`
    padding: 12px;
  `}
`;

const DarkLayer = styled.div`
  ${() => css`
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${colors.grey3};
    opacity: 0.6;
    width: 100%;
    height: 100vh;
  `}
`;

const StyledIcon = styled(Icon)`
  ${() => css`
      color: ${colors.grey3};
  `}
`;

const MobileNavigation = ({ site, pageName }: ComponentProps) => {
  const [visible, setVisible] = useState(false);
  const { logOut } = useAuth();

  return (
    <Root>
      {visible && <DarkLayer />}
      <LeftSide>
        <IconWrapper onClick={() => setVisible(!visible)}>
          <Icon icon={iconBurgerMenu} size={24} />
        </IconWrapper>
        {visible && (
          <Modal>
            <StyledWhiteBox>
              <Menu>
              </Menu>
            </StyledWhiteBox>
          </Modal>
        )}
      </LeftSide>

      <Title>
        <Header level="h1-mob">{site}</Header>
        <Paragraph>{pageName}</Paragraph>
      </Title>

      <RightSide>
        <IconWrapper onClick={logOut}>
          <StyledIcon icon={iconLogout} size={24} />
        </IconWrapper>
      </RightSide>
    </Root>
  );
};

export default MobileNavigation;
